import React from "react";
import { func, array, bool } from "prop-types";

import CardImageType9 from "../card-image-type-9";
import CardImageType10 from "../card-image-type-10";
import ReadMore from "../../atoms/read-more";
import DfpAd from "../../dfp-ad";

import "./stories-for-load-more.m.css";

const StoriesForLoadMore = ({ onLoadMore, stories, noMoreStories }) => {
  const storiesDom = stories.map((item, index) => {
    const storyObj = item.story || item;

    return (
      <React.Fragment key={index}>
        <div styleName="set-1-story">
          {index % 3 === 0 ? <CardImageType9 story={storyObj} /> : <CardImageType10 story={storyObj} />}
        </div>
        {index + 1 === 8 && (
          <div styleName="ad">
            <DfpAd adtype="leaderboard_2_728x90" />
          </div>
        )}
        {(index + 1) % 4 === 0 &&
          index + 1 >= 12 && (
            <div styleName="ad">
              <DfpAd adtype="leaderboard_2_728x90" />
            </div>
          )}
      </React.Fragment>
    );
  });

  return (
    <div styleName="stories">
      {storiesDom}
      {!noMoreStories && <ReadMore onClick={onLoadMore} />}
    </div>
  );
};

export default StoriesForLoadMore;

StoriesForLoadMore.propTypes = {
  onLoadMore: func,
  stories: array,
  noMoreStories: bool
};
